<i class="spinner position-left" [class.icon-spinner4]="spin" *ngIf="spin"></i> {{message}}
